<template>
  <div><slot></slot></div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import {mapGetters, mapState} from 'vuex';

export default {
  props: {
    shipment: {
      type: Array,
      default: () => [],
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    status: {
      type: String,
      default: '',
    },
    productType: {
      type: String,
      default: '',
    },
  },

  inject: ['container'],

  data() {
    return {};
  },
  computed: {
    hasShipped() {
      return !isEmpty(this.shipment.shipped);
    },

    hasInWarehouse() {
      return !isEmpty(this.orderData[this.productType].notShipped);
    },

    packingSlipNumber() {
      const {packingSlipNumber} = this.shipment;
      return packingSlipNumber ? packingSlipNumber : null;
    },

    packingSlipUrl() {
      if (!this.shipment) {
        return '';
      }

      const packingSlipNumber = this.packingSlipNumber;
      const shipToNumber = this.shipToNumber;

      return `${this.encodedContextPath}/my-account/packingslip-data/${packingSlipNumber}/${shipToNumber}`;
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  methods: {
    isEmpty: isEmpty,
  },
};
</script>
